"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/prefer-default-export */
var react_1 = require("react");
var AuthContext_1 = require("./AuthContext");
var utils_1 = require("../utils");
var useAuth = function () {
    var authContext = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (!authContext) {
        throw new Error('`useAuth` hook must be used within a `AuthProvider` component');
    }
    var user = authContext.user;
    var _a = (0, utils_1.getUserIdentifiers)(user), email = _a.email, userId = _a.userId, uniqueIdentifier = _a.uniqueIdentifier;
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, authContext), { userId: userId, email: email, cognitoUUID: uniqueIdentifier });
};
exports.useAuth = useAuth;
